const removeDuplicates = ({
  array,
  propertyToCheckForEquality,
}: {
  array: any[]
  propertyToCheckForEquality: string
}) =>
  array.filter(
    (v, i, array) =>
      array.findIndex(
        (vv) => v[propertyToCheckForEquality] === vv[propertyToCheckForEquality]
      ) === i
  )

// Note: Temporarily replaces .at method until we have the updated Node.
const getArrayItemAt = <T>({ arr, index }: { arr: T[]; index: number }) => {
  const sizeOffset = index < 0 ? arr.length : 0
  return arr[sizeOffset + index]
}

// TODO update this in the future to use structuredClone() once we update the node version
const deepClone = <T>(obj: T): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime()) as unknown as T
  }

  if (Array.isArray(obj)) {
    const arrCopy = [] as unknown as T[]
    ;(obj as unknown as any[]).forEach((_, i) => {
      arrCopy[i] = deepClone(obj[i])
    })
    return arrCopy as unknown as T
  }

  const cloneObj = {} as T
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(cloneObj as any)[key] = deepClone((obj as any)[key])
    }
  }
  return cloneObj
}

const exports = {
  removeDuplicates,
  getArrayItemAt,
  deepClone,
}

export default exports
